import { searchAlgoliaClient } from "shared/integrations/algolia/searchAlgoliaClient";

export const searchTagsIndex = searchAlgoliaClient.initIndex(
  process.env.REACT_APP_ALGOLIA_TAGS_INDEX_NAME ?? "",
);
